"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionIpfsContent = exports.IpfsContent = void 0;
const utils_1 = require("@subsocial/utils");
const createIpfsContent = (value) => ({ IPFS: value });
const createNoneContent = () => ({ None: null });
const createContent = (value) => (0, utils_1.nonEmptyStr)(value)
    ? createIpfsContent(value)
    : createNoneContent();
function IpfsContent(value) {
    return createContent(value);
}
exports.IpfsContent = IpfsContent;
function OptionIpfsContent(value) {
    return value ? createIpfsContent(value) : null;
}
exports.OptionIpfsContent = OptionIpfsContent;
